import { createSelector } from 'reselect'
import { ConfigManager } from '~/managers/ConfigManager'
import { CommonState } from '~/store/types'

const selectRouteState = (state: CommonState) => state.route

export const selectUser = createSelector([selectRouteState], (state) => state.user)

export const selectUserEmail = createSelector([selectUser], (user) => user.email)

export const selectUserBizId = createSelector([selectUser], (user) =>
  ConfigManager.isAppSite() ? undefined : user.bizId
)

export const selectUserIdentifier = createSelector([selectUser], (user) =>
  ConfigManager.isAppSite() ? user.kcId : user.bizId
)

export const selectUserAuthServerUrl = createSelector([selectUser], (user) => user.authServerUrl)

export const selectIsFiatWalletOnly = createSelector([selectUser], (user) =>
  ConfigManager.isBizSite() ? user.isFiatWalletOnly : false
)

export const selectIsUsingFiatCurrency = createSelector(
  [selectRouteState],
  (state) => state.isUsingFiatCurrency
)

export const selectIsTwoFaExist = createSelector(
  [selectUser],
  (user) => !!user.twoFa.twoFaList.length
)

export const selectTwoFaSetupTime = createSelector([selectUser], (user) =>
  Number(user.twoFa.twoFaSetupTime)
)

export const selectIsDashboardRevampTourDone = createSelector(
  [selectUser],
  (user) => user.isDashboardRevampTourAcknowledged
)

export const selectIsStablecoinTransferDisclaimerAcknowledged = createSelector(
  [selectUser],
  (user) => {
    if (ConfigManager.isBizSite()) {
      return false
    }
    return user.isStablecoinTransferDisclaimerAcknowledged
  }
)

export const selectFullName = createSelector([selectUser], (user) => {
  if (ConfigManager.isAppSite()) {
    return user.kycFullName
  }

  return user.businessLegalName
})

export const selectMobileNumber = createSelector([selectUser], (user) => user.mobileNumber)

export const selectIsUserInfoFromSsoInitialised = createSelector(
  [selectRouteState],
  (state) => state.isUserInfoFromSsoInitialised
)

export const selectIsUserInfoInitialised = createSelector(
  [selectRouteState],
  (state) => state.isUserInfoInitialised
)

export const selectIsActivationChecklistAcknowledged = createSelector(
  [selectUser],
  (user) => !!user.bannerDismissalState?.activation_checklist_acknowledged
)

export const selectIsFiatWithdrawalApprovalFlowEnabled = createSelector([selectUser], (user) =>
  ConfigManager.isAppSite() ? false : user.isFiatWithdrawalApprovalFlowEnabled
)

export const selectIsStablecoinWithdrawalApprovalFlowEnabled = createSelector(
  [selectUser],
  (user) => (ConfigManager.isAppSite() ? false : user.isStablecoinWithdrawalApprovalFlowEnabled)
)
